module.exports = __webpack_public_path__ + "static/media/logo-pelican@3x.eb8341d4.png";